// Novedades de la Consola que se senalan con una baliza (video aprobado "Señala lo nuevo sin estorbar").
// Cada novedad apunta a un elemento con data-baliza="…". Si ese elemento no esta en pantalla, su baliza no se ve.
// Lo visto se recuerda en este navegador.
import { readJSON, writeJSON } from './storage';

export type Novedad = {
  id: string;
  titulo: string;
  texto: string;
  selector: string;
  // Donde encontrarla si no esta en pantalla (desde la lista de novedades).
  ruta?: string;
  // Esta dentro de los ajustes del telefono (la isla).
  enTelefono?: boolean;
};

export const NOVEDADES: Novedad[] = [
  {
    id: 'reportes-3cx',
    titulo: 'Reportes 3CX',
    texto: 'Los tableros de tu central: llamadas, colas y agentes, con filtro de un clic.',
    selector: '[data-baliza="reportes-3cx"]',
    ruta: '/reportes/3cx',
  },
  {
    id: 'ensayo',
    titulo: 'Prueba tu audio',
    texto: 'Revisa micrófono, altavoces y conexión antes de tu primera llamada.',
    selector: '[data-baliza="ensayo"]',
    enTelefono: true,
  },
  {
    id: 'fecha',
    titulo: 'Elige fechas sin teclear',
    texto: 'Calendario y horas a un clic en tareas, citas y casos.',
    selector: '[data-baliza="fecha"]',
  },
  {
    id: 'permisos',
    titulo: 'Permisos del navegador',
    texto: 'Mira y activa en un solo lugar micrófono, avisos y sonido.',
    selector: '[data-baliza="permisos"]',
    ruta: '/perfil',
  },
];

export const CLAVE_NOVEDADES = 'consola.novedades.vistas';

export function leerVistas(): string[] {
  const v = readJSON<unknown>(CLAVE_NOVEDADES, []);
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}

export function guardarVistas(ids: Iterable<string>) {
  writeJSON(CLAVE_NOVEDADES, [...new Set(ids)]);
}

export const pendientes = (vistas: Iterable<string>, lista: Novedad[] = NOVEDADES) => {
  const v = new Set(vistas);
  return lista.filter((n) => !v.has(n.id));
};

// Cuantas de la lista actual ya se vieron (ids viejos que ya no estan en la lista no cuentan).
export const cuantasVistas = (vistas: Iterable<string>, lista: Novedad[] = NOVEDADES) => lista.length - pendientes(vistas, lista).length;
